export default function getResource(label, vars = []) {
    const resources = {
        all: 'Tout',
        featured: 'en vedette'
    };

    return resources[label];
}
